module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-video-8d04ce463e050d44ebb63c437bda1d58.gif";